import { mapGetters } from 'vuex';
import format from '@/common/utilities/format';


export default {
    name: 'searchFilteredMspLinks',
    inject: ['$eventBus'],
    methods: {
        track(cta) {
            this.$eventBus.$emit('ga', { ec: 'refine', en: 'click_custom', el: cta });
        },

        getPriceRangeText(filterStr) {
            const match = filterStr && filterStr.match(/price-(\d+)-(\d+)/);
            if (match) {
                const maxPrice = parseInt(match[2], 10);
                const formatPrice = format.friendlyPrice;
                return `Under $${formatPrice(maxPrice)}`;
            }
            return '';
        },

        getBedBathText(filterStr) {
            const match = filterStr && filterStr.match(/(bed|bath)-(\d+)-(\d+)/);
            if (match && match[2] === match[3]) {
                const filterType = match[1];
                const numItems = parseInt(match[2], 10);
                const singularSuffix = filterType === 'bed' ? ' bed' : ' bath';
                const pluralSuffix = filterType === 'bed' ? ' beds' : ' baths';
                return numItems === 1 ? numItems + singularSuffix : numItems + pluralSuffix;
            }
            return '';
        },

        createFilters(filters, title, baseUrl) {
            if (!filters) return null;

            const getDisplayName = (item, title) => {
                let display = '';
                switch (title) {
                    case 'Amenities':
                        display = item.display_name;
                        break;
                    case 'Price':
                        display = this.getPriceRangeText(item.attribute_id);
                        break;
                    case 'Bathrooms':
                    case 'Bedrooms':
                        display = this.getBedBathText(item.attribute_id);
                        break;
                }
                return display;
            };
            return {
                title: title,
                items: filters
                    .map((item) => {
                        const displayName = getDisplayName(item, title);
                        const fullURL = `${this.glb.appUrl}${baseUrl}${item.attribute_id}/`;
                        return displayName && fullURL ? { text: displayName, url: fullURL } : null;
                    })
                    .filter(Boolean),
            };
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('msp', ['msp', 'getGeoDisplayText']),
        getFilters() {
            let baseUrl = this.glb.geo.geoPath;
            if (!baseUrl || this.glb.geo.geoType == 'STATE') {
                return null;
            }
            baseUrl = baseUrl.includes('@') ? baseUrl.split('@')[0] : baseUrl;
            baseUrl = baseUrl.includes('dallas-tx') ? baseUrl.replace('homes-for-sale/', '') : baseUrl;

            const filters = [];
            if (this.msp.refinedInventoryCounts) {
                const { bathroomFilters, bedroomFilters, priceRangeFilters, amenitiesFilters } = this.msp.refinedInventoryCounts;
                //BATH
                const bathFilters = this.createFilters(bathroomFilters, 'Bathrooms', baseUrl);
                //BED
                const bedFilters = this.createFilters(bedroomFilters, 'Bedrooms', baseUrl);
                if (bathFilters) filters.push(bathFilters);
                if (bedFilters) filters.push(bedFilters);
                //PRICE
                if (this.msp.filter && !this.msp.filter.rentals) {
                    const priceFilters = this.createFilters(priceRangeFilters, 'Price', baseUrl);
                    if (priceFilters) {
                        filters.push(priceFilters);
                    }
                }
                //AMENITIES
                const amenities = this.createFilters(amenitiesFilters, 'Amenities', baseUrl);
                if (amenities) filters.push(amenities);
            }
            return filters?.length && {
                demographicName: this.getGeoDisplayText,
                data: filters,
            };
        },
        hasValidRefineLinks() {
            return this.getFilters.data.reduce((acc, filter) => acc || !!filter.items.length, false);
        },
    },
};
